import { defineMessages } from '@jutro/locale';

export default defineMessages({
    addNote: {
        id: 'ml.gateway.views.ActivityReports.MLNoteDetailPopup.Add Note',
        defaultMessage: 'Add Note'
    },
    cancelModal: {
        id: 'ml.gateway.views.ActivityReports.MLNoteDetailPopup.CANCEL',
        defaultMessage: 'CANCEL'
    },
    date: {
        id: 'ml.gateway.views.ActivityReports.MLNoteDetailPopup.Date',
        defaultMessage: 'Date'
    },
    policyNumber: {
        id: 'ml.gateway.views.ActivityReports.MLNoteDetailPopup.Policy Number',
        defaultMessage: 'Policy Number'
    },
    accountNumber: {
        id: 'ml.gateway.views.ActivityReports.MLNoteDetailPopup.Account Number',
        defaultMessage: 'Account Number'
    },
    category: {
        id: 'ml.gateway.views.ActivityReports.MLNoteDetailPopup.Category',
        defaultMessage: 'Category'
    },
    description: {
        id: 'ml.gateway.views.ActivityReports.MLNoteDetailPopup.Description',
        defaultMessage: 'Description'
    },
    fullDescription: {
        id: 'ml.gateway.views.ActivityReports.MLNoteDetailPopup.Full Description',
        defaultMessage: 'Full Description'
    },
    author: {
        id: 'ml.gateway.views.ActivityReports.MLNoteDetailPopup.Author',
        defaultMessage: 'Author'
    },
    noteDetails: {
        id: 'ml.gateway.views.ActivityReports.MLNoteDetailPopup.Note Details',
        defaultMessage: 'Note Details'
    },
    closeBtnLabel: {
        id: 'ml.gateway.views.ActivityReports.MLNoteDetailPopup.CLOSE',
        defaultMessage: 'CLOSE'
    }    
});
